module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [(_vm.abnormalJob === '' && _vm.timeoutJob === '' && _vm.unableFailoverJob === '') ? _c('div', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "job-alarm-empty"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("当前没有告警信息")])])])], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.abnormalJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("异常告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v(_vm._s(_vm.abnormalJob.nextFireTimeWithTimeZoneFormat))]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v(_vm._s(_vm.$map.causeMap[_vm.abnormalJob.cause]))]), _vm._v(" "), (_vm.$common.hasPerm('alarmCenter:setAbnormalJobRead', _vm.domainName)) ? _c('div', {
    staticClass: "panel-btn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.abnormalJob.read,
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.handleAbnormalJob()
      }
    }
  }, [_vm._v("不再告警")])], 1) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), (_vm.timeoutJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("超时告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v("超时秒数: " + _vm._s(_vm.timeoutJob.timeout4AlarmSeconds) + "s")]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v("超时分片: " + _vm._s(_vm.timeoutJob.timeoutItems))]), _vm._v(" "), (_vm.$common.hasPerm('alarmCenter:setTimeout4AlarmJobRead', _vm.domainName)) ? _c('div', {
    staticClass: "panel-btn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.timeoutJob.read,
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.handleTimeoutJob()
      }
    }
  }, [_vm._v("不再告警")])], 1) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), (_vm.unableFailoverJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("无法高可用告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v("域等级: " + _vm._s(_vm.$map.degreeMap[_vm.unableFailoverJob.degree]))]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v("作业等级: " + _vm._s(_vm.$map.degreeMap[_vm.unableFailoverJob.jobDegree]))])])])])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ad84592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_detail/job_alarm.vue
// module id = 1427
// module chunks = 1